import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteAdmin = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteSociete`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheAdmin = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheSociete`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerAdmin = async (idSociete) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteSociete/${idSociete}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const ModifierAdmin = async (idSociete, data) => {
    return await axios.put(`${BASE_URL}/api/societe/modifierSociete/${idSociete}`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

export { AjouteAdmin, AfficheAdmin, SuprimerAdmin, ModifierAdmin }